<div class="dialog-content">
  <mat-progress-bar *ngIf="firestore.loading" mode="indeterminate"></mat-progress-bar>
  <h1 mat-dialog-title>Add Product</h1>
  <div mat-dialog-content class="of-visible">
      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>Name</mat-label>
              <input [disabled]="firestore.loading" [(ngModel)]="newProduct.name"
                  matInput placeholder="Gaming PC" [formControl]="name">
                  @if (name.invalid) {
                    <mat-error>Please enter the product name</mat-error>
                  }
          </mat-form-field>
      </div>

      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>Description</mat-label>
              <textarea [disabled]="firestore.loading" [(ngModel)]="newProduct.description" matInput
                  placeholder="Write something about the Product"></textarea>
          </mat-form-field>
      </div>

      <div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Prozessor</mat-label>
            <input [disabled]="firestore.loading" [(ngModel)]="newProduct.prozessor" matInput
            placeholder="AMD Ryzen 9 7900X">
        </mat-form-field>
    </div>

      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>Mainboard</mat-label>
              <input [disabled]="firestore.loading" [(ngModel)]="newProduct.mainboard" matInput
              placeholder="Gigabyte Aorus Master">
          </mat-form-field>
      </div>

      <div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>GPU</mat-label>
            <input [disabled]="firestore.loading" [(ngModel)]="newProduct.gpu" matInput
            placeholder="Nvidia Gforce RTX 4090">
        </mat-form-field>
    </div>

      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>RAM</mat-label>
              <input [disabled]="firestore.loading" [(ngModel)]="newProduct.ram" matInput
                  placeholder="32 GB DDR5 6200MHZ">
          </mat-form-field>
      </div>

      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>SSD</mat-label>
              <input [disabled]="firestore.loading" [(ngModel)]="newProduct.ssd" matInput
                  placeholder="Samsung Evo 960">
          </mat-form-field>
      </div>

      <div>
          <mat-form-field appearance="outline" class="full-width">
              <mat-label>Power supply</mat-label>
              <input [disabled]="firestore.loading" [(ngModel)]="newProduct.power" matInput
                  placeholder="Gigabyte 1000W">
          </mat-form-field>
      </div>

      <div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Price</mat-label>
            <input [disabled]="firestore.loading" [(ngModel)]="newProduct.price" matInput
                placeholder="1900" [formControl]="price">
                @if (price.invalid) {
                  <mat-error>Please enter a price</mat-error>
                }
        </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
      <button mat-button [disabled]="firestore.loading" mat-dialog-close>Cancel</button>
      <button mat-button [disabled]="firestore.loading || name.invalid || price.invalid" mat-dialog-close
          (click)="saveProduct()">Save</button>
  </div>
</div>
